export default __webpack_public_path__ + "static/media/dashboard-header.a2b58b92.svg";